<template>
  <div class="mf-rich-editor" :class="{'is-focused': focused}">
    <div v-if="editor" class="mf-rich-toolbar">
      <div class="mf-rich-group">
        <button type="button" class="mf-tb-btn" :class="{'is-active': active.bold}" title="Qalin (Ctrl+B)" @click="run('toggleBold')">
          <b>B</b>
        </button>
        <button type="button" class="mf-tb-btn mf-tb-btn--italic" :class="{'is-active': active.italic}" title="Kursiv (Ctrl+I)" @click="run('toggleItalic')">
          <i>I</i>
        </button>
        <button type="button" class="mf-tb-btn mf-tb-btn--strike" :class="{'is-active': active.strike}" title="Chizilgan" @click="run('toggleStrike')">
          S
        </button>
        <button type="button" class="mf-tb-btn" :class="{'is-active': active.code}" title="Kod (inline)" @click="run('toggleCode')">
          &lt;/&gt;
        </button>
        <button
            type="button"
            class="mf-tb-btn mf-tb-btn--sup"
            :class="{'is-active': active.superscript}"
            title="Daraja — yuqori indeks (167¹, 32²)"
            @click="toggleSuperscript"
        >
          x<sup>2</sup>
        </button>
      </div>

      <span class="mf-rich-sep"/>

      <div class="mf-rich-group">
        <button type="button" class="mf-tb-btn" :class="{'is-active': active.h2}" title="Sarlavha 2" @click="toggleHeading(2)">H2</button>
        <button type="button" class="mf-tb-btn" :class="{'is-active': active.h3}" title="Sarlavha 3" @click="toggleHeading(3)">H3</button>
      </div>

      <span class="mf-rich-sep"/>

      <div class="mf-rich-group">
        <button type="button" class="mf-tb-btn" :class="{'is-active': active.bulletList}" title="Ro'yxat" @click="run('toggleBulletList')">
          <svg viewBox="0 0 16 16" width="15" height="15" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round">
            <circle cx="3" cy="4" r="1" fill="currentColor" stroke="none"/><path d="M6.5 4h7"/>
            <circle cx="3" cy="8" r="1" fill="currentColor" stroke="none"/><path d="M6.5 8h7"/>
            <circle cx="3" cy="12" r="1" fill="currentColor" stroke="none"/><path d="M6.5 12h7"/>
          </svg>
        </button>
        <button type="button" class="mf-tb-btn" :class="{'is-active': active.orderedList}" title="Raqamli ro'yxat" @click="run('toggleOrderedList')">
          <svg viewBox="0 0 16 16" width="15" height="15" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round">
            <path d="M6.5 4h7M6.5 8h7M6.5 12h7"/>
            <text x="1.5" y="5.4" font-size="5" fill="currentColor" stroke="none">1</text>
            <text x="1.5" y="9.4" font-size="5" fill="currentColor" stroke="none">2</text>
            <text x="1.5" y="13.4" font-size="5" fill="currentColor" stroke="none">3</text>
          </svg>
        </button>
        <button type="button" class="mf-tb-btn" :class="{'is-active': active.blockquote}" title="Iqtibos" @click="run('toggleBlockquote')">
          <svg viewBox="0 0 16 16" width="15" height="15" fill="currentColor">
            <path d="M3 4h4v4a3 3 0 0 1-3 3v-1.6A1.4 1.4 0 0 0 5.4 8H3zM9 4h4v4a3 3 0 0 1-3 3v-1.6A1.4 1.4 0 0 0 11.4 8H9z"/>
          </svg>
        </button>
        <button type="button" class="mf-tb-btn" :class="{'is-active': active.codeBlock}" title="Kod bloki" @click="run('toggleCodeBlock')">
          <svg viewBox="0 0 16 16" width="15" height="15" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
            <path d="M6 5 3 8l3 3M10 5l3 3-3 3"/>
          </svg>
        </button>
      </div>

      <span class="mf-rich-sep"/>

      <div class="mf-rich-group">
        <button type="button" class="mf-tb-btn" :class="{'is-active': active.link}" title="Havola" @click="setLink">
          <svg viewBox="0 0 16 16" width="15" height="15" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
            <path d="M6.5 9.5 9.5 6.5"/><path d="M7 4.5 8 3.5a2.5 2.5 0 0 1 3.5 3.5l-1 1"/><path d="M9 11.5 8 12.5a2.5 2.5 0 0 1-3.5-3.5l1-1"/>
          </svg>
        </button>
        <button type="button" class="mf-tb-btn" title="Jadval qo'shish" @click="insertTable">
          <svg viewBox="0 0 16 16" width="15" height="15" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round">
            <rect x="2" y="3" width="12" height="10" rx="1.5"/><path d="M2 6.5h12M2 10h12M6.5 3v10"/>
          </svg>
        </button>
        <button type="button" class="mf-tb-btn" title="Ajratuvchi chiziq" @click="run('setHorizontalRule')">
          <svg viewBox="0 0 16 16" width="15" height="15" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round">
            <path d="M2.5 8h11"/>
          </svg>
        </button>
      </div>

      <div class="mf-rich-group mf-rich-group--right">
        <button type="button" class="mf-tb-btn" :disabled="!active.canUndo" title="Bekor qilish (Ctrl+Z)" @click="run('undo')">
          <svg viewBox="0 0 16 16" width="15" height="15" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
            <path d="M6 4 3 7l3 3"/><path d="M3 7h6.5A3.5 3.5 0 0 1 13 10.5v0A3.5 3.5 0 0 1 9.5 14H7"/>
          </svg>
        </button>
        <button type="button" class="mf-tb-btn" :disabled="!active.canRedo" title="Qaytarish (Ctrl+Y)" @click="run('redo')">
          <svg viewBox="0 0 16 16" width="15" height="15" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
            <path d="M10 4l3 3-3 3"/><path d="M13 7H6.5A3.5 3.5 0 0 0 3 10.5v0A3.5 3.5 0 0 0 6.5 14H9"/>
          </svg>
        </button>
      </div>
    </div>

    <!-- table controls appear only while the caret is inside a table -->
    <div v-if="editor && active.table" class="mf-rich-tabletools">
      <button type="button" @click="run('addColumnAfter')">＋ Ustun</button>
      <button type="button" @click="run('addRowAfter')">＋ Qator</button>
      <button type="button" @click="run('deleteColumn')">－ Ustun</button>
      <button type="button" @click="run('deleteRow')">－ Qator</button>
      <button type="button" class="is-danger" @click="run('deleteTable')">Jadvalni o'chirish</button>
    </div>

    <editor-content :editor="editor" class="mf-rich-content"/>
  </div>
</template>

<script>
import {Editor, EditorContent} from "@tiptap/vue-3";
import StarterKit from "@tiptap/starter-kit";
import Link from "@tiptap/extension-link";
import Placeholder from "@tiptap/extension-placeholder";
import Table from "./tiptapMarkdownTable";
import TableRow from "@tiptap/extension-table-row";
import TableCell from "@tiptap/extension-table-cell";
import TableHeader from "@tiptap/extension-table-header";
import {Markdown} from "tiptap-markdown";
import {ElMessage} from "element-plus";
import {TextSelection} from "@tiptap/pm/state";
import {toSuperscript, fromSuperscript, isSuperscript, hasSuperscriptForm} from "./superscript";

export default {
  name: "MfMarkdownEditor",
  components: {EditorContent},
  props: {
    modelValue: {type: String, default: ""},
    placeholder: {type: String, default: "Matn kiriting..."},
  },
  emits: ["update:modelValue"],
  data() {
    return {
      editor: null,
      focused: false,
      // Toolbar active/enabled flags, refreshed on every editor transaction so
      // the buttons reflect the caret's current formatting reactively.
      active: {
        bold: false, italic: false, strike: false, code: false,
        h2: false, h3: false, bulletList: false, orderedList: false,
        blockquote: false, codeBlock: false, link: false, table: false,
        superscript: false, canUndo: false, canRedo: false,
      },
    };
  },
  watch: {
    modelValue(value) {
      // Sync only when the incoming value differs from what the editor already
      // holds — avoids cursor jumps and update loops on our own emits.
      if (!this.editor) return;
      const current = this.editor.storage.markdown.getMarkdown();
      if (value !== current) {
        this.editor.commands.setContent(value || "", false);
      }
    },
  },
  mounted() {
    this.editor = new Editor({
      content: this.modelValue || "",
      extensions: [
        StarterKit.configure({heading: {levels: [1, 2, 3]}}),
        Link.configure({
          openOnClick: false,
          autolink: true,
          HTMLAttributes: {rel: "noopener nofollow", target: "_blank"},
        }),
        Placeholder.configure({placeholder: this.placeholder}),
        Table.configure({resizable: true}),
        TableRow,
        TableHeader,
        TableCell,
        // html:false neutralizes raw HTML in the markdown (no HTML injection).
        Markdown.configure({html: false, tightLists: true, linkify: true, breaks: false}),
      ],
      onUpdate: () => {
        this.$emit("update:modelValue", this.editor.storage.markdown.getMarkdown());
        this.refreshToolbar();
      },
      onSelectionUpdate: () => this.refreshToolbar(),
      onTransaction: () => this.refreshToolbar(),
      onFocus: () => {
        this.focused = true;
      },
      onBlur: () => {
        this.focused = false;
      },
    });
    this.refreshToolbar();
  },
  beforeUnmount() {
    this.editor?.destroy();
  },
  methods: {
    refreshToolbar() {
      const e = this.editor;
      if (!e) return;
      this.active = {
        bold: e.isActive("bold"),
        italic: e.isActive("italic"),
        strike: e.isActive("strike"),
        code: e.isActive("code"),
        h2: e.isActive("heading", {level: 2}),
        h3: e.isActive("heading", {level: 3}),
        bulletList: e.isActive("bulletList"),
        orderedList: e.isActive("orderedList"),
        blockquote: e.isActive("blockquote"),
        codeBlock: e.isActive("codeBlock"),
        link: e.isActive("link"),
        table: e.isActive("table"),
        // Not a mark — the button lights up when the selected text is already
        // raised, signalling that clicking again puts it back on the baseline.
        superscript: isSuperscript(this.selectedText()),
        canUndo: e.can().undo(),
        canRedo: e.can().redo(),
      };
    },
    // Plain text of the current selection; "" when the caret is collapsed.
    selectedText() {
      const {from, to, empty} = this.editor.state.selection;
      if (empty) return "";
      return this.editor.state.doc.textBetween(from, to, "\n");
    },
    // Daraja (yuqori indeks): raises the selected digits to Unicode superscript
    // characters — 167 + "1" -> 167¹ — and lowers them again on a second click.
    // With no selection it asks for the value, the same way setLink() does.
    toggleSuperscript() {
      const {from, to, empty} = this.editor.state.selection;

      if (empty) {
        const value = window.prompt("Daraja (yuqori indeks) qiymati:", "");
        if (value === null || !value.trim()) return;
        if (!hasSuperscriptForm(value)) {
          ElMessage.warning("Daraja sifatida faqat raqam va + - = ( ) belgilarini kiritish mumkin");
          return;
        }
        this.editor.chain().focus().insertContent(toSuperscript(value)).run();
        return;
      }

      const text = this.selectedText();
      // A selection spanning several blocks (or a table/image) has a length that
      // no longer matches the document range, so replacing it as flat text would
      // destroy structure. Superscript is an inline touch-up anyway.
      if (to - from !== text.length) {
        ElMessage.warning("Bitta qatordagi matnni belgilang");
        return;
      }

      const raised = isSuperscript(text);
      if (!raised && !hasSuperscriptForm(text)) {
        ElMessage.warning("Belgilangan matnda daraja ko'rinishi bor belgi yo'q (raqam yoki + - = ( ))");
        return;
      }
      const converted = raised ? fromSuperscript(text) : toSuperscript(text);

      // insertText keeps the surrounding marks (bold, link, ...) and stays a
      // single history step; the editor's own insertContent would re-parse the
      // string as markdown. The range is re-selected so the click can be undone
      // by clicking the button once more.
      const tr = this.editor.state.tr.insertText(converted, from, to);
      tr.setSelection(TextSelection.create(tr.doc, from, from + converted.length));
      this.editor.view.dispatch(tr);
      this.editor.commands.focus();
    },
    // Generic dispatcher: this.run('toggleBold') -> editor.chain().focus().toggleBold().run()
    run(command) {
      this.editor.chain().focus()[command]().run();
    },
    toggleHeading(level) {
      this.editor.chain().focus().toggleHeading({level}).run();
    },
    setLink() {
      const previous = this.editor.getAttributes("link").href;
      const url = window.prompt("Havola manzili (URL):", previous || "https://");
      if (url === null) return; // cancelled
      if (url === "") {
        this.editor.chain().focus().extendMarkRange("link").unsetLink().run();
        return;
      }
      this.editor.chain().focus().extendMarkRange("link").setLink({href: url}).run();
    },
    insertTable() {
      this.editor.chain().focus().insertTable({rows: 3, cols: 3, withHeaderRow: true}).run();
    },
  },
};
</script>

<style scoped lang="scss">
$brand: #007791;
$border: #dcdfe6;

.mf-rich-editor {
  width: 100%;
  box-sizing: border-box;
  border: 1px solid $border;
  border-radius: 8px;
  overflow: hidden;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;

  &.is-focused {
    border-color: $brand;
    box-shadow: 0 0 0 2px rgba(0, 119, 145, 0.12);
  }
}

/* ---- toolbar ---- */
.mf-rich-toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px;
  padding: 6px 8px;
  background: #f6f9fc;
  border-bottom: 1px solid #eef1f6;
}

.mf-rich-group {
  display: inline-flex;
  align-items: center;
  gap: 2px;

  &--right {
    margin-left: auto;
  }
}

.mf-rich-sep {
  width: 1px;
  height: 18px;
  margin: 0 4px;
  background: #dfe4ec;
}

.mf-tb-btn {
  min-width: 28px;
  height: 28px;
  padding: 0 6px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid transparent;
  border-radius: 6px;
  background: transparent;
  color: #4a5468;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.12s ease;

  svg {
    display: block;
  }

  &:hover {
    background: rgba(0, 119, 145, 0.1);
    color: $brand;
  }

  &.is-active {
    background: $brand;
    border-color: $brand;
    color: #fff;
  }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
    background: transparent;
    color: #4a5468;
  }

  &--italic i {
    font-family: Georgia, serif;
  }

  &--strike {
    text-decoration: line-through;
  }

  &--sup {
    font-family: Georgia, serif;

    sup {
      font-size: 0.7em;
      line-height: 0;
      vertical-align: super;
    }
  }
}

/* ---- table sub-toolbar ---- */
.mf-rich-tabletools {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  padding: 6px 8px;
  background: #eef4f7;
  border-bottom: 1px solid #e2e9ee;

  button {
    height: 26px;
    padding: 0 10px;
    border: 1px solid #cdd8e0;
    border-radius: 6px;
    background: #fff;
    color: #46586a;
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.12s ease;

    &:hover {
      border-color: $brand;
      color: $brand;
    }

    &.is-danger:hover {
      border-color: #f56c6c;
      color: #f56c6c;
    }
  }
}

/* ---- editable content ---- */
.mf-rich-content {
  :deep(.ProseMirror) {
    min-height: 280px;
    padding: 14px 16px;
    outline: none;
    font-size: 14px;
    line-height: 1.7;
    color: #303133;

    > * + * {
      margin-top: 0.7em;
    }

    p.is-editor-empty:first-child::before {
      content: attr(data-placeholder);
      float: left;
      height: 0;
      color: #b6bec9;
      pointer-events: none;
    }

    // "Montserrat" is loaded only at weight 300 → force the real bold face.
    strong, b {
      font-family: "Montserrat-Bold", sans-serif;
      font-weight: 700;
    }

    h1, h2, h3 {
      font-family: "Montserrat-Bold", sans-serif;
      line-height: 1.3;
      color: #0a194e;
    }

    h1 { font-size: 1.5em; }
    h2 {
      font-size: 1.28em;
      padding-bottom: 0.2em;
      border-bottom: 1px solid #eef1f6;
    }
    h3 { font-size: 1.13em; }

    ul, ol {
      padding-left: 1.4em;
    }

    ul li::marker {
      color: $brand;
    }

    blockquote {
      margin: 0.6em 0;
      padding: 4px 14px;
      border-left: 3px solid $brand;
      background: #f8fafc;
      border-radius: 0 6px 6px 0;
      color: #555;
    }

    a {
      color: $brand;
      text-decoration: underline;
      cursor: pointer;
    }

    code {
      background: #f5f7fa;
      padding: 1px 5px;
      border-radius: 4px;
      font-size: 0.9em;
    }

    pre {
      background: #2d2d3a;
      color: #f4f4f5;
      padding: 12px 14px;
      border-radius: 8px;
      overflow: auto;

      code {
        background: none;
        padding: 0;
        color: inherit;
        font-size: 0.88em;
      }
    }

    hr {
      border: none;
      border-top: 1px solid #dcdfe6;
      margin: 1em 0;
    }

    // tables
    table {
      border-collapse: collapse;
      width: 100%;
      margin: 0.6em 0;
      overflow: hidden;

      td, th {
        border: 1px solid #dcdfe6;
        padding: 6px 10px;
        vertical-align: top;
        position: relative;
      }

      th {
        background: #f6f9fc;
        color: #0a194e;
        font-weight: 600;
        text-align: left;
      }

      .selectedCell::after {
        content: "";
        position: absolute;
        inset: 0;
        background: rgba(0, 119, 145, 0.12);
        pointer-events: none;
      }

      .column-resize-handle {
        position: absolute;
        right: -2px;
        top: 0;
        bottom: 0;
        width: 4px;
        background: $brand;
        pointer-events: none;
      }
    }
  }
}
</style>
